import wavingWithYourEyeClosed from 'assets/images/characters/CarolinaMariadeJesus/waving-with-your-eye-closed.webp';
import {useNavigate} from 'react-router-dom';
import {Button} from 'components/ui';

import styles from './TeacherRevisionPending.module.scss';

export type TeacherRevisionPendingVariant =
  | 'pending'
  | 'expired_composition'
  | 'abandonment_rule_violated';

interface TeacherRevisionPendingProps {
  variant?: TeacherRevisionPendingVariant;
}

const CONTENT: Record<TeacherRevisionPendingVariant, JSX.Element> = {
  pending: (
    <>
      <p>Sua redação foi enviada com sucesso!</p>
      <p>
        A devolutiva fica disponível para todos assim que o período da atividade
        encerrar. Lembre-se de voltar para conferir quando isso acontecer,
        certo?
      </p>
    </>
  ),
  expired_composition: (
    <>
      <p>O tempo da sua atividade encerrou.</p>
      <p>
        Sua redação não foi finalizada a tempo. A atividade foi encerrada
        automaticamente com o que foi salvo até o momento.
      </p>
    </>
  ),
  abandonment_rule_violated: (
    <>
      <p>Sua atividade em Modo Foco foi encerrada.</p>
      <p>
        Você saiu da plataforma mais vezes do que o permitido ou não retornou
        dentro do tempo disponível. Por isso, a atividade foi encerrada e os
        dados não foram enviados ao professor.
      </p>
    </>
  ),
};

const DEFAULT_CONTENT = (
  <>
    Seu professor está revisando sua redação. Em breve você receberá a
    devolutiva! Lembre-se de voltar para conferir, certo?
  </>
);

function TeacherRevisionPending({variant}: TeacherRevisionPendingProps) {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.pendingReviewCard}>
        <img
          src={wavingWithYourEyeClosed}
          alt="Personagem Carolina Maria de Jesus acenando"
          className={styles.pendingReviewImage}
        />

        <div className={styles.pendingReviewText}>
          {variant ? CONTENT[variant] : DEFAULT_CONTENT}
        </div>

        <Button
          variant="primary"
          type="button"
          onClick={() => navigate('/')}
          text="Certo!"
        />
      </div>
    </div>
  );
}

export default TeacherRevisionPending;
